import { useCreateUnlimitedGoalsAllowed } from 'features/goals';
import React from 'react';
import { EmptyGoals } from 'shared/components/ui/empty-goals';
import { useOpenCreateGoalDialog } from 'shared/contexts/goal-form';
import { useOpenPremiumDialog } from 'shared/contexts/premium-dialog';
import { ID } from 'shared/types/id';

import * as Styled from './empty-banner.style';

export type EmptyBannerProps = {
  lifeAreaId?: ID;
};

export const EmptyBanner: React.FC<EmptyBannerProps> = ({ lifeAreaId }) => {
  const openPremiumDialog = useOpenPremiumDialog();
  const openCreateGoalDialog = useOpenCreateGoalDialog();
  const { allowed: createGoalAllowed } = useCreateUnlimitedGoalsAllowed();

  const onAdd = () =>
    createGoalAllowed
      ? openCreateGoalDialog({ lifeAreaId })
      : openPremiumDialog();

  return (
    <Styled.EmptyContainer>
      <EmptyGoals onAdd={onAdd} />
    </Styled.EmptyContainer>
  );
};
